import { Box, Button, Grid, TableCell, TableRow } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { formatMoney } from '../../../utils';
import { convertToFinalPrice } from '../../../finalPrice';
import { TicketSellingRangeChip } from './TicketBlock';

const ActivitiesTableItem = ({
    activity,
    currentFilters,
    setCurrentFilters,
    showCommission,
    showSellingRanges,
    isAdmin
}) => {
    const { company, name, id, firstTimeslot } = activity;

    // respect the showEmpty filter as well
    if (currentFilters.showEmpty === false && !firstTimeslot) {
        return null;
    }

    return (
        <TableRow>
            {isAdmin && <TableCell>{activity?.island?.name}</TableCell>}
            <TableCell>{company?.name}</TableCell>
            <TableCell>
                {name}
                {activity?.featured && (
                    <Box
                        component="span"
                        style={{
                            backgroundColor: '#FFD700',
                            color: '#000',
                            padding: '2px 6px',
                            borderRadius: 4,
                            marginLeft: 8,
                            fontSize: 12,
                            fontWeight: 'bold'
                        }}
                    >
                        Featured
                    </Box>
                )}
                {activity?.hasCommissionBoost && (
                    <Box
                        component="span"
                        title={`Extra commission up to ${formatMoney(
                            (activity.maxExtraCommission || 0) / 100
                        )}`}
                        style={{
                            backgroundColor: '#e65100',
                            color: '#fff',
                            padding: '2px 6px',
                            borderRadius: 4,
                            marginLeft: 8,
                            fontSize: 12,
                            fontWeight: 'bold'
                        }}
                    >
                        Commission boost
                    </Box>
                )}
            </TableCell>
            <TableCell>{company?.contact_phone?.reservation}</TableCell>
            <TableCell>
                {firstTimeslot
                    ? moment(firstTimeslot.start_time).format('h:mm a ddd, MMMM DD')
                    : '-'}
            </TableCell>
            <TableCell align="right">
                <Grid container justifyContent="flex-end" direction="column">
                    {activity.tickets?.map((ticket, idx) => {
                        let price = convertToFinalPrice(ticket.retail_price, ticket?.final_price);
                        if (firstTimeslot && typeof firstTimeslot.prices[id] !== 'undefined') {
                            price = firstTimeslot.prices[id];
                        }
                        return (
                            // eslint-disable-next-line react/no-array-index-key
                            <Grid
                                item
                                key={idx}
                                style={{
                                    marginBottom: 4,
                                    alignItems: 'center',
                                    display: 'flex',
                                    gap: 4
                                }}
                            >
                                <span>{`${ticket.name} - ${formatMoney(price)}`}</span>
                                {showCommission && (
                                    <Box>
                                        <b>({formatMoney(ticket.agentCommission)})</b>
                                    </Box>
                                )}
                                <Box display="flex" alignItems="center">
                                    {!showSellingRanges && (
                                        <TicketSellingRangeChip ticket={ticket} />
                                    )}
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </TableCell>
            <TableCell>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                        setCurrentFilters({
                            ...currentFilters,
                            activityId: id
                        })
                    }
                >
                    Book Now
                </Button>
            </TableCell>
        </TableRow>
    );
};

export default ActivitiesTableItem;
